var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      !_vm.$wait.is("fetching preview resource")
        ? [
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("The Project")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(1)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(1) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(1)
                  ? [
                      _c("div", { staticClass: "company-info" }, [
                        _c("h2", [_vm._v(_vm._s(_vm.resource.projectName))]),
                      ]),
                      _vm._v(" "),
                      _vm.resource.lead
                        ? _c(
                            "div",
                            { staticClass: "profile-list" },
                            [
                              _c("p", { staticClass: "profile-list__title" }, [
                                _vm._v("Lead User"),
                              ]),
                              _vm._v(" "),
                              _c("UserCard", {
                                attrs: {
                                  user: _vm.resource.lead,
                                  borderless: true,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filterLead(_vm.resource.team).length
                        ? _c("div", { staticClass: "profile-list" }, [
                            _c("p", { staticClass: "profile-list__title" }, [
                              _vm._v("Users also involved"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "grid" },
                              _vm._l(
                                _vm.filterLead(_vm.resource.team),
                                function (profile) {
                                  return _c(
                                    "div",
                                    { key: profile.id, staticClass: "col-3" },
                                    [
                                      _c("UserCard", {
                                        attrs: {
                                          user: profile,
                                          small: true,
                                          borderless: true,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("The Company")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(2)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(2) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(2)
                  ? [
                      _c("div", { staticClass: "company-info" }, [
                        _vm.resource.member.country
                          ? _c("img", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: _vm.resource.country.name,
                                  expression: "resource.country.name",
                                },
                              ],
                              attrs: { src: _vm.resource.country.flag },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.resource.companyName))]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "grid post-details" }, [
                          _vm.resource.completedAt
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Completed Date"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", {
                                      attrs: { icon: "calendar" },
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.resource.completedAt)
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.location
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Location of Activities"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", {
                                      attrs: { icon: "location" },
                                    }),
                                    _vm._v(" " + _vm._s(_vm.resource.location)),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.dealType
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Deal Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", { attrs: { icon: "deal" } }),
                                    _vm._v(" " + _vm._s(_vm.resource.dealType)),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.counterpartCompany
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Counterpart Company"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", {
                                      attrs: { icon: "company" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.resource.counterpartCompany)
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.resource.activity
                          ? _c(
                              "div",
                              { staticClass: "card", attrs: { id: "bio" } },
                              [
                                _c("div", { staticClass: "header" }, [
                                  _vm._v("Company Bio"),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.resource.activity),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.tombstone
                          ? _c(
                              "div",
                              {
                                staticClass: "card",
                                attrs: { id: "tombstone" },
                              },
                              [
                                _c("div", { staticClass: "header" }, [
                                  _vm._v("Tombstone company description"),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.resource.tombstone),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("The Deal")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(3)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(3) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(3)
                  ? [
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.transactionCurrency
                          ? _c("li", { staticClass: "col-2 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Currency"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "strong",
                                [
                                  _c("SvgIcon", { attrs: { icon: "money" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.resource.transactionCurrency)
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.transactionValue
                          ? _c("li", { staticClass: "col-2 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Transaction Value"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "strong",
                                [
                                  _c("SvgIcon", { attrs: { icon: "value" } }),
                                  _vm.resource.transactionCurrency
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resource.transactionCurrency
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "  " +
                                      _vm._s(_vm.resource.transactionValue) +
                                      "m"
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.sectors
                          ? _c(
                              "li",
                              { staticClass: "col-6 detail" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Sectors"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.resource.sectors, function (sector) {
                                  return _c("span", { staticClass: "sector" }, [
                                    _vm._v(_vm._s(sector.name)),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.resource.dealSummary
                        ? _c(
                            "div",
                            { staticClass: "card", attrs: { id: "summary" } },
                            [
                              _c("div", { staticClass: "header" }, [
                                _vm._v("Deal Summary"),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.resource.dealSummary),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("The Impact")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(4)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(4) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(4)
                  ? [
                      _vm.resource.differenceMade
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("The value the user added to the project"),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.resource.differenceMade),
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resource.testimonial
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("Testimonial"),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.resource.testimonial),
                              },
                            }),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.resource.testimonialPerson
                              ? _c("span", [
                                  _vm._v(
                                    "- " +
                                      _vm._s(_vm.resource.testimonialPerson)
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form__group form__group--submit-fixed" },
                [
                  _vm.resource.can.delete
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: [
                                "saving preview resource",
                                "deleting preview resource",
                              ],
                              expression:
                                "['saving preview resource', 'deleting preview resource']",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--danger",
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteModal()
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\tDelete MADD\n\t\t\t\t\t")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: "saving preview resource",
                          expression: "'saving preview resource'",
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn",
                      on: {
                        click: function ($event) {
                          return _vm.saveResource(0)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t\tSave and Leave\n\t\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _vm.resource.can.approve
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: "saving preview resource",
                              expression: "'saving preview resource'",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--primary btn--no-stretch",
                          on: {
                            click: function ($event) {
                              return _vm.saveResource(2)
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\tApprove and Post\n\t\t\t\t\t")]
                      )
                    : _vm.resource.can.submit
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: "saving preview resource",
                              expression: "'saving preview resource'",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--primary btn--no-stretch",
                          on: {
                            click: function ($event) {
                              return _vm.saveResource(1)
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\tSubmit MADD\n\t\t\t\t\t")]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }